import { Component, OnInit, Input, ChangeDetectorRef, Inject } from '@angular/core';

import { Controllers } from '@shared/core/controllers';
import * as Tokens from '@shared/core/tokens';

import { TilesComponent } from '../../tiles.shared.component';

@Component({
    selector: 'shared-tile-for-loyalty-free-product',
    templateUrl: './tile-for-loyalty-free-product.shared.component.html',
    styleUrls: ['./tile-for-loyalty-free-product.shared.component.scss']
})
export class TileForLoyaltyFreeProductComponent extends TilesComponent implements OnInit {
    @Input() public programItem!: OLO.Ordering.ILoyaltyFreeProductItemModel;
    @Input() public feel!: OLO.Components.BOX_FEEL;

    constructor(
        @Inject(Tokens.CONFIG_TOKEN) public config: IConfig,
        public changeDetectorRef: ChangeDetectorRef,
        public controllers: Controllers,
    ) {
        super(changeDetectorRef, controllers);
    }

    ngOnInit(): void {
    }

    public handleClick($event: Event): void {
        console.log('tile clicked', this.programItem);
    }

    public get boxFeel(): OLO.Components.BOX_FEEL {
        return this.feel || this.config.ui?.loyalty?.freeProductTile?.feel || 'gold';
    }

    public get titleInverted(): boolean {
        return this.config.ui?.loyalty?.freeProductTile?.titleInverted !== undefined ? this.config.ui?.loyalty?.freeProductTile?.titleInverted : true;
    }
}
